import { Injectable } from '@angular/core';

import {
    WorldActivatorService
} from '../core/upgraded-providers';

import { VersionService } from '../version.service';
import { SessionService } from '../session.service';

@Injectable()
export class NwMenuService {    
    constructor(
        private _versionSrv: VersionService,
        private _sessionSrv: SessionService,

        private _worldActivatorService: WorldActivatorService,
    ) {
    }

    async connect(server: IServer) {
        this._worldActivatorService.welcomeDialogDisplayed = false;

        // TODO: Save selected server, use it to restore connection settings after refresh page in nw
        await this._sessionSrv.initSessionServer(server);

        if (this._versionSrv.data.protocol !== nw.App.manifest.protocolVersion) {
            throw 'protocol';
        }
    }
}
